const EXTENSION_CATEGORY = {
  pdf: "pdf",
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  bmp: "image",
  svg: "image",
  webp: "image",
  tiff: "image",
  tif: "image",
  ico: "image",
  doc: "document",
  docx: "document",
  txt: "document",
  rtf: "document",
  odt: "document",
  xls: "spreadsheet",
  xlsx: "spreadsheet",
  csv: "spreadsheet",
  ods: "spreadsheet",
  ppt: "presentation",
  pptx: "presentation",
  odp: "presentation",
  mp4: "video",
  avi: "video",
  mov: "video",
  wmv: "video",
  flv: "video",
  webm: "video",
  mkv: "video",
  m4v: "video",
  "3gp": "video",
  mp3: "audio",
  wav: "audio",
  flac: "audio",
  aac: "audio",
  ogg: "audio",
  wma: "audio",
  m4a: "audio",
  zip: "archive",
  rar: "archive",
  "7z": "archive",
  tar: "archive",
  gz: "archive",
  bz2: "archive",
  js: "code",
  jsx: "code",
  ts: "code",
  tsx: "code",
  html: "code",
  css: "code",
  scss: "code",
  sass: "code",
  json: "code",
  xml: "code",
  py: "code",
  java: "code",
  cpp: "code",
  c: "code",
  php: "code",
  rb: "code",
  go: "code",
  rs: "code",
  swift: "code",
  kt: "code",
};

export function getEnhancementFileCategory(fileName) {
  if (!fileName) return "default";
  const extension = fileName.split(".").pop()?.toLowerCase();
  return EXTENSION_CATEGORY[extension] || "default";
}

export const ENHANCEMENT_FILE_COLOR_BY_CATEGORY = {
  pdf: "error",
  image: "success",
  document: "primary",
  spreadsheet: "warning",
  presentation: "warning",
  video: "secondary",
  audio: "info",
  archive: "warning",
  code: "primary",
  default: "default",
};
